"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmpli = exports.flushAmpli = exports.accountBlocked = exports.pricingViewed = exports.tsOneLinkClicked = exports.onboardingButtonClicked = exports.freeTeamSelected = exports.userIdentify = exports.screenViewed = exports.setUserId = exports.resetUser = exports.AmplitudeAccountBlockedReasons = exports.AmplitudeScreenNames = void 0;
const amplitude = __importStar(require("@amplitude/analytics-browser"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const ampli_1 = require("../ampli");
var AmplitudeScreenNames;
(function (AmplitudeScreenNames) {
    AmplitudeScreenNames["SIGNUP"] = "Onboarding: Create Account FALL 2024";
    AmplitudeScreenNames["ROLE_SELECT"] = "Onboarding: Create or Join Team FALL 2024";
    AmplitudeScreenNames["TEAM_CREATE"] = "Onboarding: Create Team FALL 2024";
    AmplitudeScreenNames["PLAN_SELECT"] = "Onboarding: Select Plan FALL 2024";
    AmplitudeScreenNames["PLAN_SELECT_2025"] = "Onboarding: Select Plan April 2025";
    AmplitudeScreenNames["PLAN_SUCCESS"] = "Onboarding: Create Plan Success FALL 2024";
    AmplitudeScreenNames["CLAIM_INVITE"] = "User Activation: Create Password";
    AmplitudeScreenNames["INVITE_ROLE"] = "Invite Accept: Parent Player Selection";
    AmplitudeScreenNames["PLAYER_DETAILS"] = "Invite Accept: Player Profile Details";
    AmplitudeScreenNames["TS_PLUS_OFFER"] = "Invite Accept: TS+ Offer";
    AmplitudeScreenNames["TS_PLUS_OFFER_2025"] = "Invite Accept: TS+ Offer May 2025";
    AmplitudeScreenNames["ACCOUNT_SETTINGS"] = "Account Settings";
})(AmplitudeScreenNames || (exports.AmplitudeScreenNames = AmplitudeScreenNames = {}));
var AmplitudeAccountBlockedReasons;
(function (AmplitudeAccountBlockedReasons) {
    AmplitudeAccountBlockedReasons["AGE"] = "Age Less than 13";
})(AmplitudeAccountBlockedReasons || (exports.AmplitudeAccountBlockedReasons = AmplitudeAccountBlockedReasons = {}));
const resetUser = () => {
    const ampliClient = ampli_1.ampli?.client;
    const ampliUserId = ampliClient?.getUserId();
    ampliUserId && ampliClient?.reset();
};
exports.resetUser = resetUser;
const setUserId = (userId) => {
    const ampliClient = ampli_1.ampli?.client;
    const ampliUserId = ampliClient?.getUserId();
    userId !== ampliUserId && ampliClient?.setUserId(userId);
};
exports.setUserId = setUserId;
const screenViewed = (screenName) => {
    ampli_1.ampli?.track({
        event_type: 'Screen Viewed',
        event_properties: { screen_name: screenName },
    });
};
exports.screenViewed = screenViewed;
const userIdentify = (userId, userProps) => {
    const ampliClient = ampli_1.ampli?.client;
    const identifyEvent = new amplitude.Identify();
    for (const [key, value] of Object.entries(userProps)) {
        // set or unset the key based on the value
        // if the value is null, unset the key
        value != null ? identifyEvent.set(key, value) : identifyEvent.unset(key);
    }
    ampliClient?.identify(identifyEvent, { user_id: userId });
};
exports.userIdentify = userIdentify;
const freeTeamSelected = (teamId, screenName) => {
    ampli_1.ampli?.freeTeamSelected({ team_id: teamId, screen_name: screenName });
    ampli_1.ampli.flush(); // flush the event immediately since it navigates away
};
exports.freeTeamSelected = freeTeamSelected;
const onboardingButtonClicked = (buttonName, screenName) => {
    ampli_1.ampli?.onboardingButtonClicked({
        onboarding_button_name: buttonName,
        screen_name: screenName,
    });
};
exports.onboardingButtonClicked = onboardingButtonClicked;
const tsOneLinkClicked = (screenName) => {
    ampli_1.ampli?.ts1AppButtonClicked({
        screen_name: screenName,
    });
    ampli_1.ampli.flush(); // flush the event immediately since it navigates away
};
exports.tsOneLinkClicked = tsOneLinkClicked;
const pricingViewed = (trialShown, basicShown, screenName) => {
    ampli_1.ampli?.teamSubscriptionPricingViewed({
        trial_shown: trialShown,
        basic_shown: basicShown,
        screen_name: screenName,
    });
};
exports.pricingViewed = pricingViewed;
const accountBlocked = (blockReason, buttonName, screenName) => {
    ampli_1.ampli?.teamSnapAccountBlocked({
        block_reason: blockReason,
        onboarding_button_name: buttonName,
        screen_name: screenName,
    });
};
exports.accountBlocked = accountBlocked;
const flushAmpli = async () => {
    if (window.Cypress || !ampli_1.ampli)
        return Promise.resolve();
    await ampli_1.ampli.flush();
};
exports.flushAmpli = flushAmpli;
const useAmpli = () => {
    const { teamId } = (0, react_router_1.useParams)();
    const user = (0, react_redux_1.useSelector)((state) => state?.user);
    const userId = user?.user?.uciUuid;
    const userEmail = user?.user?.email;
    React.useEffect(() => {
        if (userId) {
            (0, exports.setUserId)(userId);
            userEmail && (0, exports.userIdentify)(userId, { email: userEmail });
        }
    }, [userId]);
    return {
        user,
        resetUser: exports.resetUser,
        identify: (userProps) => (0, exports.userIdentify)(userId, userProps),
        screenViewed: exports.screenViewed,
        freeTeamSelected: () => (0, exports.freeTeamSelected)(teamId, AmplitudeScreenNames.PLAN_SELECT),
        pricingViewed: (trialShown, basicShown, screenName = AmplitudeScreenNames.PLAN_SELECT) => (0, exports.pricingViewed)(trialShown, basicShown, screenName),
        onboardingButtonClicked: exports.onboardingButtonClicked,
        accountBlocked: exports.accountBlocked,
        tsOneLinkClicked: exports.tsOneLinkClicked,
    };
};
exports.useAmpli = useAmpli;
